export const DISTRICTS = {
    Adana: [
        "Aladağ", "Ceyhan", "Çukurova", "Feke", "İmamoğlu", "Karaisalı", "Karataş", "Kozan",
        "Pozantı", "Saimbeyli", "Sarıçam", "Seyhan", "Tufanbeyli", "Yumurtalık", "Yüreğir"
    ],
    Adıyaman: [
        "Adıyaman Merkez", "Besni", "Çelikhan", "Gerger", "Gölbaşı", "Kahta", "Samsat", "Sincik", "Tut"
    ],
    Afyonkarahisar: [
        "Afyonkarahisar Merkez", "Başmakçı", "Bayat", "Bolvadin", "Çay", "Çobanlar", "Dazkırı", "Dinar",
        "Emirdağ", "Evciler", "Hocalar", "İhsaniye", "İscehisar", "Kızılören", "Sandıklı",
        "Sinanpaşa", "Sultandağı", "Şuhut"
    ],
    Ağrı: [
        "Ağrı Merkez", "Diyadin", "Doğubayazıt", "Eleşkirt", "Hamur", "Patnos", "Taşlıçay", "Tutak"
    ],
    Aksaray: [
        "Aksaray Merkez", "Ağaçören", "Eskil", "Gülağaç", "Güzelyurt", "Ortaköy", "Sarıyahşi", "Sultanhanı"
    ],
    Amasya: [
        "Amasya Merkez", "Göynücek", "Gümüşhacıköy", "Hamamözü", "Merzifon", "Suluova", "Taşova"
    ],
    Ankara: [
        "Akyurt", "Altındağ", "Ayaş", "Bala", "Beypazarı", "Çamlıdere", "Çankaya", "Çubuk",
        "Elmadağ", "Etimesgut", "Evren", "Gölbaşı", "Güdül", "Haymana", "Kahramankazan",
        "Kalecik", "Keçiören", "Kızılcahamam", "Mamak", "Nallıhan", "Polatlı", "Pursaklar",
        "Sincan", "Şereflikoçhisar", "Yenimahalle"
    ],
    Antalya: [
        "Akseki", "Aksu", "Alanya", "Demre", "Döşemealtı", "Elmalı", "Finike", "Gazipaşa",
        "Gündoğmuş", "İbradı", "Kaş", "Kemer", "Kepez", "Konyaaltı", "Korkuteli", "Kumluca",
        "Manavgat", "Muratpaşa", "Serik"
    ],
    Ardahan: [
        "Ardahan Merkez", "Çıldır", "Damal", "Göle", "Hanak", "Posof"
    ],
    Artvin: [
        "Artvin Merkez", "Ardanuç", "Arhavi", "Borçka", "Hopa", "Kemalpaşa", "Murgul", "Şavşat", "Yusufeli"
    ],
    Aydın: [
        "Bozdoğan", "Buharkent", "Çine", "Didim", "Efeler", "Germencik", "İncirliova", "Karacasu",
        "Karpuzlu", "Koçarlı", "Köşk", "Kuşadası", "Kuyucak", "Nazilli", "Söke", "Sultanhisar", "Yenipazar"
    ],
    Balıkesir: [
        "Altıeylül", "Ayvalık", "Balya", "Bandırma", "Bigadiç", "Burhaniye", "Dursunbey", "Edremit",
        "Erdek", "Gömeç", "Gönen", "Havran", "İvrindi", "Karesi", "Kepsut", "Manyas", "Marmara",
        "Savaştepe", "Sındırgı", "Susurluk"
    ],
    Bartın: [
        "Bartın Merkez", "Amasra", "Kurucaşile", "Ulus"
    ],
    Batman: [
        "Batman Merkez", "Beşiri", "Gercüş", "Hasankeyf", "Kozluk", "Sason"
    ],
    Bayburt: [
        "Bayburt Merkez", "Aydıntepe", "Demirözü"
    ],
    Bilecik: [
        "Bilecik Merkez", "Bozüyük", "Gölpazarı", "İnhisar", "Osmaneli", "Pazaryeri", "Söğüt", "Yenipazar"
    ],
    Bingöl: [
        "Bingöl Merkez", "Adaklı", "Genç", "Karlıova", "Kiğı", "Solhan", "Yayladere", "Yedisu"
    ],
    Bitlis: [
        "Bitlis Merkez", "Adilcevaz", "Ahlat", "Güroymak", "Hizan", "Mutki", "Tatvan"
    ],
    Bolu: [
        "Bolu Merkez", "Dörtdivan", "Gerede", "Göynük", "Kıbrıscık", "Mengen", "Mudurnu", "Seben", "Yeniçağa"
    ],
    Burdur: [
        "Burdur Merkez", "Ağlasun", "Altınyayla", "Bucak", "Çavdır", "Çeltikçi", "Gölhisar", "Karamanlı",
        "Kemer", "Tefenni", "Yeşilova"
    ],
    Bursa: [
        "Büyükorhan", "Gemlik", "Gürsu", "Harmancık", "İnegöl", "İznik", "Karacabey", "Keles",
        "Kestel", "Mudanya", "Mustafakemalpaşa", "Nilüfer", "Orhaneli", "Orhangazi", "Osmangazi",
        "Yenişehir", "Yıldırım"
    ],
    Çanakkale: [
        "Ayvacık", "Bayramiç", "Biga", "Bozcaada", "Çan", "Çanakkale Merkez", "Eceabat", "Ezine",
        "Gelibolu", "Gökçeada", "Lapseki", "Yenice"
    ],
    Çankırı: [
        "Çankırı Merkez", "Atkaracalar", "Bayramören", "Çerkeş", "Eldivan", "Ilgaz", "Kızılırmak",
        "Korgun", "Kurşunlu", "Orta", "Şabanözü", "Yapraklı"
    ],
    Çorum: [
        "Çorum Merkez", "Alaca", "Bayat", "Boğazkale", "Dodurga", "İskilip", "Kargı", "Laçin",
        "Mecitözü", "Oğuzlar", "Ortaköy", "Osmancık", "Sungurlu", "Uğurludağ"
    ],
    Denizli: [
        "Acıpayam", "Babadağ", "Baklan", "Bekilli", "Beyağaç", "Bozkurt", "Buldan", "Çal",
        "Çameli", "Çardak", "Çivril", "Güney", "Honaz", "Kale", "Merkezefendi", "Pamukkale",
        "Sarayköy", "Serinhisar", "Tavas"
    ],
    Diyarbakır: [
        "Bağlar", "Bismil", "Çermik", "Çınar", "Çüngüş", "Dicle", "Eğil", "Ergani",
        "Hani", "Hazro", "Kayapınar", "Kocaköy", "Kulp", "Lice", "Silvan", "Sur", "Yenişehir"
    ],
    Düzce: [
        "Düzce Merkez", "Akçakoca", "Cumayeri", "Çilimli", "Gölyaka", "Gümüşova", "Kaynaşlı", "Yığılca"
    ],
    Edirne: [
        "Edirne Merkez", "Enez", "Havsa", "İpsala", "Keşan", "Lalapaşa", "Meriç", "Süloğlu", "Uzunköprü"
    ],
    Elazığ: [
        "Elazığ Merkez", "Ağın", "Alacakaya", "Arıcak", "Baskil", "Karakoçan", "Keban", "Kovancılar",
        "Maden", "Palu", "Sivrice"
    ],
    Erzincan: [
        "Erzincan Merkez", "Çayırlı", "İliç", "Kemah", "Kemaliye", "Otlukbeli", "Refahiye", "Tercan", "Üzümlü"
    ],
    Erzurum: [
        "Aşkale", "Aziziye", "Çat", "Hınıs", "Horasan", "İspir", "Karaçoban", "Karayazı",
        "Köprüköy", "Narman", "Oltu", "Olur", "Palandöken", "Pasinler", "Pazaryolu", "Şenkaya",
        "Tekman", "Tortum", "Uzundere", "Yakutiye"
    ],
    Eskişehir: [
        "Alpu", "Beylikova", "Çifteler", "Günyüzü", "Han", "İnönü", "Mahmudiye", "Mihalgazi",
        "Mihalıççık", "Odunpazarı", "Sarıcakaya", "Seyitgazi", "Sivrihisar", "Tepebaşı"
    ],
    Gaziantep: [
        "Araban", "Fıstıkkent", "İslahiye", "Karkamış", "Nizip", "Nurdağı", "Oğuzeli",
        "Şahinbey", "Şehitkamil", "Yavuzeli"
    ],
    Giresun: [
        "Giresun Merkez", "Alucra", "Bulancak", "Çamoluk", "Çanakçı", "Dereli", "Doğankent", "Espiye",
        "Eynesil", "Görele", "Güce", "Keşap", "Piraziz", "Şebinkarahisar", "Tirebolu", "Yağlıdere"
    ],
    Gümüşhane: [
        "Gümüşhane Merkez", "Kelkit", "Köse", "Kürtün", "Şiran", "Torul"
    ],
    Hakkari: [
        "Hakkari Merkez", "Çukurca", "Derecik", "Şemdinli", "Yüksekova"
    ],
    Hatay: [
        "Altınözü", "Antakya", "Arsuz", "Belen", "Defne", "Dörtyol", "Erzin", "Hassa",
        "İskenderun", "Kırıkhan", "Kumlu", "Payas", "Reyhanlı", "Samandağ", "Yayladağı"
    ],
    Iğdır: [
        "Iğdır Merkez", "Aralık", "Karakoyunlu", "Tuzluca"
    ],
    Isparta: [
        "Isparta Merkez", "Aksu", "Atabey", "Eğirdir", "Gelendost", "Gönen", "Keçiborlu",
        "Senirkent", "Sütçüler", "Şarkikaraağaç", "Uluborlu", "Yalvaç", "Yenişarbademli"
    ],
    İstanbul: [
        "Adalar", "Arnavutköy", "Ataşehir", "Avcılar", "Bağcılar", "Bahçelievler", "Bakırköy",
        "Başakşehir", "Bayrampaşa", "Beşiktaş", "Beykoz", "Beylikdüzü", "Beyoğlu", "Büyükçekmece",
        "Çatalca", "Çekmeköy", "Esenler", "Esenyurt", "Eyüpsultan", "Fatih", "Gaziosmanpaşa",
        "Güngören", "Kadıköy", "Kağıthane", "Kartal", "Küçükçekmece", "Maltepe", "Pendik",
        "Sancaktepe", "Sarıyer", "Silivri", "Sultanbeyli", "Sultangazi", "Şile", "Şişli",
        "Tuzla", "Ümraniye", "Üsküdar", "Zeytinburnu"
    ],
    İzmir: [
        "Aliağa", "Balçova", "Bayındır", "Bayraklı", "Bergama", "Beydağ", "Bornova", "Buca",
        "Çeşme", "Çiğli", "Dikili", "Foça", "Gaziemir", "Güzelbahçe", "Karabağlar", "Karaburun",
        "Karşıyaka", "Kemalpaşa", "Kınık", "Kiraz", "Konak", "Menderes", "Menemen", "Narlıdere",
        "Ödemiş", "Seferihisar", "Selçuk", "Tire", "Torbalı", "Urla"
    ],
    Kahramanmaraş: [
        "Afşin", "Andırın", "Çağlayancerit", "Dulkadiroğlu", "Ekinözü", "Elbistan", "Göksun",
        "Nurhak", "Onikişubat", "Pazarcık", "Türkoğlu"
    ],
    Karabük: [
        "Karabük Merkez", "Eflani", "Eskipazar", "Ovacık", "Safranbolu", "Yenice"
    ],
    Karaman: [
        "Karaman Merkez", "Ayrancı", "Başyayla", "Ermenek", "Kazımkarabekir", "Sarıveliler"
    ],
    Kars: [
        "Kars Merkez", "Akyaka", "Arpaçay", "Digor", "Kağızman", "Sarıkamış", "Selim", "Susuz"
    ],
    Kastamonu: [
        "Kastamonu Merkez", "Abana", "Ağlı", "Araç", "Azdavay", "Cide", "Çatalzeytin", "Daday",
        "Devrekani", "Doğanyurt", "Hanönü", "İhsangazi", "İnebolu", "Küre", "Pınarbaşı",
        "Seydiler", "Şenpazar", "Taşköprü", "Tosya"
    ],
    Kayseri: [
        "Akkışla", "Bünyan", "Develi", "Felahiye", "Hacılar", "İncesu", "Kocasinan", "Melikgazi",
        "Özvatan", "Pınarbaşı", "Sarıoğlan", "Sarız", "Talas", "Tomarza", "Yahyalı", "Yeşilhisar"
    ],
    Kilis: [
        "Kilis Merkez", "Elbeyli", "Musabeyli", "Polateli"
    ],
    Kırıkkale: [
        "Kırıkkale Merkez", "Bahşılı", "Balışeyh", "Çelebi", "Delice", "Karakeçili", "Keskin",
        "Sulakyurt", "Yahşihan"
    ],
    Kırklareli: [
        "Kırklareli Merkez", "Babaeski", "Demirköy", "Kofçaz", "Lüleburgaz", "Pehlivanköy", "Pınarhisar", "Vize"
    ],
    Kırşehir: [
        "Kırşehir Merkez", "Akçakent", "Akpınar", "Boztepe", "Çiçekdağı", "Kaman", "Mucur"
    ],
    Kocaeli: [
        "Başiskele", "Çayırova", "Darıca", "Derince", "Dilovası", "Gebze", "Gölcük", "İzmit",
        "Kandıra", "Karamürsel", "Kartepe", "Körfez"
    ],
    Konya: [
        "Ahırlı", "Akören", "Akşehir", "Altınekin", "Beyşehir", "Boğazkent", "Cihanbeyli", "Çeltik",
        "Çumra", "Derbent", "Derebucak", "Doğanhisar", "Emirgazi", "Ereğli", "Güneysınır",
        "Hadim", "Halkapınar", "Hüyük", "Ilgın", "Kadınhanı", "Karapınar", "Karatay",
        "Kulu", "Meram", "Sarayönü", "Selçuklu", "Seydişehir", "Taşkent", "Tuzlukçu",
        "Yalıhüyük", "Yunak"
    ],
    Kütahya: [
        "Kütahya Merkez", "Altıntaş", "Aslanapa", "Çavdarhisar", "Domaniç", "Dumlupınar", "Emet",
        "Gediz", "Hisarcık", "Pazarlar", "Simav", "Şaphane", "Tavşanlı"
    ],
    Malatya: [
        "Akçadağ", "Arapgir", "Arguvan", "Darende", "Doğanşehir", "Doğanyol", "Hekimhan", "Kale",
        "Kuluncak", "Malatya Merkez", "Pütürge", "Yazıhan", "Yeşilyurt"
    ],
    Manisa: [
        "Ahmetli", "Akhisar", "Alaşehir", "Demirci", "Gölmarmara", "Gördes", "Kırkağaç", "Köprübaşı",
        "Kula", "Salihli", "Sarıgöl", "Saruhanlı", "Selendi", "Soma", "Şehzadeler", "Turgutlu", "Yunusemre"
    ],
    Mardin: [
        "Artuklu", "Dargeçit", "Derik", "Kızıltepe", "Mazıdağı", "Midyat", "Nusaybin", "Ömerli",
        "Savur", "Yeşilli"
    ],
    Mersin: [
        "Akdeniz", "Anamur", "Aydıncık", "Bozyazı", "Çamlıyayla", "Erdemli", "Gülnar", "Mezitli",
        "Mut", "Silifke", "Tarsus", "Toroslar", "Yenişehir"
    ],
    Muğla: [
        "Bodrum", "Dalaman", "Datça", "Fethiye", "Kavaklıdere", "Köyceğiz", "Marmaris", "Menteşe",
        "Milas", "Ortaca", "Seydikemer", "Ula", "Yatağan"
    ],
    Muş: [
        "Muş Merkez", "Bulanık", "Hasköy", "Korkut", "Malazgirt", "Varto"
    ],
    Nevşehir: [
        "Nevşehir Merkez", "Acıgöl", "Avanos", "Derinkuyu", "Gülşehir", "Hacıbektaş", "Kozaklı", "Ürgüp"
    ],
    Niğde: [
        "Niğde Merkez", "Altunhisar", "Bor", "Çamardı", "Çiftlik", "Ulukışla"
    ],
    Ordu: [
        "Akkuş", "Altınordu", "Aybastı", "Çamaş", "Çatalpınar", "Çaybaşı", "Fatsa", "Gölköy",
        "Gürgentepe", "İkizce", "Kabadüz", "Kabataş", "Korgan", "Kumru", "Mesudiye",
        "Perşembe", "Ulubey", "Ünye"
    ],
    Osmaniye: [
        "Osmaniye Merkez", "Bahçe", "Düziçi", "Hasanbeyli", "Kadirli", "Sumbas", "Toprakkale"
    ],
    Rize: [
        "Rize Merkez", "Ardeşen", "Çamlıhemşin", "Çayeli", "Derepazarı", "Fındıklı", "Güneysu",
        "Hemşin", "İkizdere", "İyidere", "Kalkandere", "Pazar"
    ],
    Sakarya: [
        "Adapazarı", "Akyazı", "Arifiye", "Erenler", "Ferizli", "Geyve", "Hendek", "Karapürçek",
        "Karasu", "Kaynarca", "Kocaali", "Pamukova", "Sapanca", "Serdivan", "Söğütlü", "Taraklı"
    ],
    Samsun: [
        "Alaçam", "Atakum", "Ayvacık", "Bafra", "Canik", "Çarşamba", "Havza", "İlkadım",
        "Kavak", "Ladik", "Ondokuzmayıs", "Salıpazarı", "Tekkeköy", "Terme", "Vezirköprü", "Yakakent"
    ],
    Siirt: [
        "Siirt Merkez", "Baykan", "Eruh", "Kurtalan", "Pervari", "Şirvan", "Tillo"
    ],
    Sinop: [
        "Sinop Merkez", "Ayancık", "Boyabat", "Dikmen", "Durağan", "Erfelek", "Gerze", "Saraydüzü", "Türkeli"
    ],
    Sivas: [
        "Sivas Merkez", "Akıncılar", "Altınyayla", "Divriği", "Doğanşar", "Gemerek", "Gölova", "Gürün",
        "Hafik", "İmranlı", "Kangal", "Koyulhisar", "Suşehri", "Şarkışla", "Ulaş", "Yıldızeli", "Zara"
    ],
    Şanlıurfa: [
        "Akçakale", "Birecik", "Bozova", "Ceylanpınar", "Eyyübiye", "Halfeti", "Haliliye", "Harran",
        "Hilvan", "Karaköprü", "Siverek", "Suruç", "Viranşehir"
    ],
    Şırnak: [
        "Şırnak Merkez", "Beytüşşebap", "Cizre", "Güçlükonak", "İdil", "Silopi", "Uludere"
    ],
    Tekirdağ: [
        "Çerkezköy", "Çorlu", "Ergene", "Hayrabolu", "Kapaklı", "Malkara", "Marmaraereğlisi",
        "Muratlı", "Saray", "Süleymanpaşa", "Şarköy"
    ],
    Tokat: [
        "Tokat Merkez", "Almus", "Artova", "Başçiftlik", "Erbaa", "Niksar", "Pazar", "Reşadiye",
        "Sulusaray", "Turhal", "Yeşilyurt", "Zile"
    ],
    Trabzon: [
        "Akçaabat", "Araklı", "Arsin", "Beşikdüzü", "Çarşıbaşı", "Çaykara", "Dernekpazarı", "Düzköy",
        "Hayrat", "Köprübaşı", "Maçka", "Of", "Ortahisar", "Sürmene", "Şalpazarı", "Tonya",
        "Vakfıkebir", "Yomra"
    ],
    Tunceli: [
        "Tunceli Merkez", "Çemişgezek", "Hozat", "Mazgirt", "Nazımiye", "Ovacık", "Pertek", "Pülümür"
    ],
    Uşak: [
        "Uşak Merkez", "Banaz", "Eşme", "Karahallı", "Sivaslı", "Ulubey"
    ],
    Van: [
        "Bahçesaray", "Başkale", "Çaldıran", "Çatak", "Edremit", "Erciş", "Gevaş", "Gürpınar",
        "İpekyolu", "Muradiye", "Özalp", "Saray", "Tuşba"
    ],
    Yalova: [
        "Yalova Merkez", "Altınova", "Armutlu", "Çınarcık", "Çiftlikköy", "Termal"
    ],
    Yozgat: [
        "Yozgat Merkez", "Akdağmadeni", "Aydıncık", "Boğazlıyan", "Çandır", "Çayıralan", "Çekerek",
        "Kadışehri", "Saraykent", "Sarıkaya", "Sorgun", "Şefaatli", "Yenifakılı", "Yerköy"
    ],
    Zonguldak: [
        "Zonguldak Merkez", "Alaplı", "Çaycuma", "Devrek", "Gökçebey", "Karadeniz Ereğli", "Kilimli", "Kozlu"
    ]
};